module.exports = __webpack_public_path__ + "static/media/safe.65cd96c7.svg";